export enum RbacRole {
  Admin = "admin",
  Member = "member",
}
export interface patchRbacRoleBody {
  new_role: RbacRole;
}

export interface patchRbacRoleResponse {
  status: string;
}
